export default "__VITE_ASSET__eGjRCMmZ__"